import { render, staticRenderFns } from "./GenericTablePagination.vue?vue&type=template&id=336b3339&"
import script from "./GenericTablePagination.vue?vue&type=script&lang=js&"
export * from "./GenericTablePagination.vue?vue&type=script&lang=js&"
import style0 from "./GenericTablePagination.vue?vue&type=style&index=0&id=336b3339&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports